import StoredLayout from '../../layouts/StoredLayout'
import Reactable from './Reactable'
export default StoredLayout(Reactable)
